import React from 'react';

import configDefault from '../../../config/configDefault';
import { twitterPageURL } from '../../../util/urlHelpers';
import {
  LayoutSingleColumn,
} from '../../../components';
import Footer from '../../../components/Footer/Footer';
import StaticPage from '../../../containers/PageBuilder/StaticPage';
import TopbarContainer from '../../../containers/TopbarContainer/TopbarContainer';

import css from './FAQPage.module.css';

const FAQPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = configDefault;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="Frequently Asked Questions"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        description: 'FAQs — Frequently Asked Questions',
        name: 'FAQ page',
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<Footer />}
      >
        <h1 className={css.pageTitle}>Frequently Asked Questions</h1>

        <div className={css.contentWrapper}>
          <div className={css.contentMain}>
            <h2>
              No questions so far. 😄
            </h2>

            <h2 id="contact">Reach us at:</h2>
            <code><b>info@platemarked.com</b></code>
          </div>
        </div>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FAQPage;
